import savegreenactivity1 from "../../../assets/CampuLifeImages/savegreenactivity1.jpg"
import savegreenactivity2 from "../../../assets/CampuLifeImages/savegreenactivity2.jpg"
import savegreenactivity3 from "../../../assets/CampuLifeImages/savegreenactivity3.jpg"
import savegreenactivity4 from "../../../assets/CampuLifeImages/savegreenactivity4.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import savegreenbanner from "../../../assets/CampuLifeImages/savegreenbanner.jpg"


const SaveGreen = () => {
   
   const data = 
    { 
            name:"savegreen",
      viewmore:"true",
      hover:true,
      viewless:"true",
      pagename: "Save Green Club", 
      title: "Save Green Club Activities",
      contentImg:savegreenbanner,
      para:"“Save Green club empower students to participate in meaningful environmental activities around the college through effective use of resources.”" ,
      paraobjective:"Objectives :",
      paratitle:"Strategies :",
      objectivepoints:["To conserve bio-diversity.","To create attitude towards nature and to maintain sustainable resource use.","To promote eco-friendly environment in the campus.",],
      paratitlecontents:[
        {content:"To initiate aims to instill a sense of empathy and social responsibility among our students."},
        {content:"To create awareness about environmental issues."},
        {content:"To celebrate festivals like World Environment day, Forest day, Van mahotsav day, Ozone day etc.."},
        {content:"To motivate the students to imbibe habits and lifestyle for minimum waste generation, separation of waste, Reuse of waste material & preparation of products out of waste then disposing the waste to the nearest storage point."},
        {content:"To motivate the students to keep their surrounding green and clean by undertaking plantation of Trees."}
      ],
      fourhover:true
     
    }
   
   const hoverContent =[
     {  img: savegreenactivity1, para1: "Mushroom cultivation & Spawn making, Tissue Culture programme, conducted by Dr. N. Jeyakumar, Former Senior Lecturer, Faculty of Medicine, Unit of Microbiology, AIMST University, Malaysia.", para2: "October 30, 2023" },
     {  img: savegreenactivity2, para1: "An awareness programme on Eco friendly Agriculture conducted by Agri.Dr.Y,RajaKumar,B.Sc.,B,sc.(Agri),Hons.,B.G.L.,M.A.,D.F.T", para2: "March 4, 2024" },
     {  img: savegreenactivity3, para1: "Sapling plantation drive.", para2: "September 30, 2024" },
     {  img: savegreenactivity4, para1: "Craft making and Recycling drive,Pine apple toy making by using  waste bottle, Bracelet making by using beads organized by Malaviya Vidya Kendram School,Kumaracoil", para2: "October 7, 2024" }
 ]

 const tableData = [
  {title:"Save Green Club Organizers"},
  {headings:[{heading1:"S.No",heading2:"Name",heading3:"Designation & Department",heading4:"Position"}]},
  {data:[{ id: 1, name: 'Dr. S. Sreedevi', designDept:"Assitant Professor ,Microbiology" ,pos:"Convenor"},
  { id: 2, name: 'Dr. J. Jose Hepzin Alis', designDept:"Assitant Professor ,Chemistry" ,pos:"Member" }]},
  {padding:true}
];
  return (
    <>
    <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
   </>
  )
}

export default SaveGreen
